import { takeEvery, call, put, all } from "redux-saga/effects";
import { submitForm, setStatusDoctorCreate } from "../constants";
import { doctorCreate } from "../api/doctorCreate.api";
import { stateProps } from "../types";
import { onChangeErrorStatusSubmit } from "../actions/index";

interface payloadProps {
  type: string;
  doctorDetails: stateProps;
  loginStatus: string;
}

function* handleSubmitDoctor(payload: payloadProps) {
  try {
    const result: { message?: any } = yield call(doctorCreate, payload.doctorDetails);
    if (result.message) {
      yield put(onChangeErrorStatusSubmit(true, "API Fetch Server Error !!!"));
    } else {
      yield all([
        put({
          type: setStatusDoctorCreate,
          doctorCreateStatus: true,
        }),
        put(onChangeErrorStatusSubmit(false, "")),
      ]);
      localStorage.clear();
    }
  } catch (error) {
    yield put(onChangeErrorStatusSubmit(true, "API Fetch Server Error !!!"));
  }
}

export default function* signUpDoctor() {
  yield takeEvery(submitForm, handleSubmitDoctor);
}
